var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "VTooltip",
    _vm._b(
      {
        staticClass: "km-tooltip-portal-component",
        attrs: {
          tag: "div",
          contentClass: _vm.contentClass,
          activator: _vm.activator,
          value: _vm.show,
          zIndex: 1000,
        },
      },
      "VTooltip",
      _vm.attrs,
      false
    ),
    [_c("Vnodes", { attrs: { vnodes: _vm.content } })],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }